import React from 'react'
import { useTranslation } from 'react-i18next'
import { SectionShell } from '../shared/SectionShell'
import { OrbitalMark } from '../shared/OrbitalMark'

export default function HeroSection() {
    const { t } = useTranslation()

    return (
        <SectionShell id="hero" className="hero">
            <div className="hero-bg-arc" aria-hidden="true">
                <svg viewBox="0 0 800 800" fill="none" width="800" height="800">
                    <circle cx="400" cy="400" r="340" stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.06" />
                    <circle cx="400" cy="400" r="260" stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.06" />
                    <circle cx="400" cy="400" r="180" stroke="currentColor" strokeWidth="0.5" strokeOpacity="0.08" />
                </svg>
            </div>

            <div className="hero-inner">
                <div className="hero-corner hero-corner-tl" aria-hidden="true">
                    <span className="hero-glyph">+ 00</span>
                </div>
                <div className="hero-corner hero-corner-tr" aria-hidden="true">
                    <span className="hero-glyph">HERO +</span>
                </div>

                <div className="hero-orb-wrap">
                    <OrbitalMark width={220} height={220} className="hero-orb" />
                </div>

                <h1 className="hero-title">{t('hero.title')}</h1>
                <p className="hero-subtitle">{t('hero.subtitle')}</p>

                <div className="hero-chips">
                    <span className="hero-chip">{t('hero.chip1')}</span>
                    <span className="hero-chip">{t('hero.chip2')}</span>
                    <span className="hero-chip">{t('hero.chip3')}</span>
                </div>

                <div className="hero-corner hero-corner-bl" aria-hidden="true">
                    <span className="hero-glyph">SYS / ONLINE</span>
                </div>
                <div className="hero-corner hero-corner-br" aria-hidden="true">
                    <span className="hero-glyph">{t('hero.role')}</span>
                </div>
            </div>

            <div className="hero-scroll-hint" aria-hidden="true">
                <span className="hero-scroll-line" />
                <span className="hero-scroll-label">SCROLL</span>
            </div>
        </SectionShell>
    )
}
